import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createApp } from 'vue'
import TDesign from 'tdesign-vue-next'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import permission from './directives/permission'
import { setupActionAudit } from '@/utils/action-audit'

// 引入TDesign样式
import 'tdesign-vue-next/es/style/index.css'

// 引入全局统一表单样式
import './styles/common-form.css'

// XINBA design system. Tailwind utilities use the `tw-` prefix and preflight
// is disabled, so loading the framework does not reset existing pages.
import './design-system/styles/tokens.css'
import './design-system/styles/foundation.css'
import './design-system/styles/filters.css'
import './design-system/styles/adapters.css'
import './design-system/styles/tailwind.css'

// 全局定义defineOptions
window.defineOptions = function(options) {
  return options;
};

// 处理 ResizeObserver 错误
const debounce = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
};

// 创建一个防抖的错误处理函数
const debouncedResizeObserverError = debounce((error) => {
  if (error.message === 'ResizeObserver loop completed with undelivered notifications.') {
    error.preventDefault();
    error.stopPropagation();
  }
}, 100);

// 添加错误处理
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.preventDefault();
    e.stopPropagation();
    debouncedResizeObserverError(e);
    return false;
  }
});

// 添加全局 ResizeObserver 错误处理
if (window.ResizeObserver) {
  const originalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends originalResizeObserver {
    constructor(callback) {
      super((...args) => {
        requestAnimationFrame(() => {
          callback(...args);
        });
      });
    }
  };
}

const app = createApp(App)

app.use(TDesign)
app.use(createPinia())
app.use(router)

// 全局记录按钮点击，并自动关联点击后发起的业务请求。
setupActionAudit(router)

// 注册权限指令
app.directive('permission', permission)

app.mount('#app')
